import { useStaticQuery, graphql } from "gatsby"

// only one query per file, so we put each url in its own file

export const useCandidatureManagementTeaserUrl = () => {
  const data = useStaticQuery(candidatureManagementTeaserUrlQuery)
  return (data.pssHeaderLink || {}).url
}

const candidatureManagementTeaserUrlQuery = graphql`
  query CandidatureManagementTeaserQuery {
    pssHeaderLink(key: { eq: "candidatureManagementTeaserUrl" }) {
      url
    }
  }
`
